class SyncUTMsToCart {
    constructor() {
        this.utms = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
        this.targetUrlPatterns = [
            "change.js",
            "add.js",
            "change",
            "add",
            "update.js",
        ];
        this.originalSend = null;
        this.originalFetch = null;
        
        // Shopify Storefront API configuration
        this.storefrontApiUrl = 'https://prostandard.myshopify.com/api/2025-04/graphql.json';
        this.storefrontAccessToken = 'dd8e9c2ef1a28ca69bb3aeadfb6eeddb'; // TODO: Replace with actual Storefront API access token from Shopify Admin
        
        // Target metafield keys
        this.targetMetafields = ['league', 'gender', 'department', 'team', 'capsule'];
        
        this.init();
    }

    init() {
        this.setCampaignUTMsToSessionStorage();
        this.setupURLChangeListener();
    }

    setCampaignUTMsToSessionStorage() {
        const storedUTMs = sessionStorage.getItem('campaignUTMs');
        if (!storedUTMs) {
            const utms = this.getUTMParams();
            if (Object.keys(utms).length > 0) {
                sessionStorage.setItem('campaignUTMs', JSON.stringify(utms));
            }
        }
    }

    getUTMParams() {
        const params = new URLSearchParams(window.location.search);
        const utms = {};
        this.utms.forEach(key => {
            if (params.has(key)) {
                utms[key] = params.get(key);
            }
        });
        return utms;
    }

    async updateCartAttributes(utms) {
        const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ attributes: utms })
        });
        return response.json();
    }

    async syncUTMsToCart() {
        const storedUTMs = sessionStorage.getItem('campaignUTMs');
        if (storedUTMs) {
            const utms = JSON.parse(storedUTMs);
            await this.updateCartAttributes(utms);
            console.log('UTMs synced to cart', utms);
        }
    }

    async fetchProductsMetafields(productIds) {
        try {
            if (!productIds || productIds.length === 0) {
                return {};
            }

            const query = `
                query MyQuery($ids: [ID!]!) {
                    nodes(ids: $ids) {
                        ... on Product {
                            id
                            league: metafield(key: "league" , namespace: "custom") {
                                value
                                key
                            }
                            gender: metafield(key: "gender" , namespace: "custom") {
                                value
                                key
                            }
                            department: metafield(key: "department" , namespace: "custom") {
                                value
                                key
                            }
                            team: metafield(key: "team" , namespace: "custom") {
                                value
                                key
                            }
                            capsule: metafield(key: "capsule" , namespace: "custom") {
                                value
                                key
                            }
                        }
                    }
                }
            `;

            const variables = {
                ids: productIds.map(id => `gid://shopify/Product/${id}`)
            };

            const response = await fetch(this.storefrontApiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': this.storefrontAccessToken
                },
                body: JSON.stringify({ query, variables })
            });

            if (!response.ok) {
                throw new Error(`GraphQL request failed: ${response.status}`);
            }

            const data = await response.json();
            
            if (data.errors) {
                throw new Error(`GraphQL errors: ${JSON.stringify(data.errors)}`);
            }

            // Process the response and create a mapping of product ID to metafields
            const productMetafieldsMap = {};
            
            if (data.data?.nodes) {
                data.data.nodes.forEach(node => {
                    if (node && node.id) {
                        // Extract product ID from the GraphQL ID
                        const productId = node.id.split('/').pop();
                        const metafields = {};
                        
                        // Extract each metafield if it exists
                        this.targetMetafields.forEach(key => {
                            if (node[key] && node[key].value) {
                                try {
                                    // Parse JSON string values (e.g., "[\"WNBA\"]" -> ["WNBA"])
                                    let parsedValue = node[key].value;
                                    
                                    // Try to parse as JSON array first
                                    if (parsedValue.startsWith('[') && parsedValue.endsWith(']')) {
                                        const arrayValue = JSON.parse(parsedValue);
                                        // If it's an array, take the first value or join with comma
                                        parsedValue = Array.isArray(arrayValue) ? arrayValue.join(', ') : parsedValue;
                                    }
                                    
                                    metafields[key] = parsedValue;
                                } catch (parseError) {
                                    // If JSON parsing fails, use the raw value
                                    metafields[key] = node[key].value;
                                }
                            }
                        });
                        
                        if (Object.keys(metafields).length > 0) {
                            productMetafieldsMap[productId] = metafields;
                        }
                    }
                });
            }

            return productMetafieldsMap;
        } catch (error) {
            console.error('Error fetching products metafields:', error);
            return {};
        }
    }

    async updateCartLineProperties(lineItemKey, metafields) {
        debugger
        try {
            const properties = {};
            Object.keys(metafields).forEach(key => {
                properties[`_${key}`] = metafields[key];
            });

            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: lineItemKey,
                    properties: properties
                })
            });

            if (!response.ok) {
                throw new Error(`Cart update failed: ${response.status}`);
            }

            const result = await response.json();
            console.log('Cart line properties updated:', properties);
            return result;
        } catch (error) {
            console.error('Error updating cart line properties:', error);
            return null;
        }
    }


    async getCartData() {
        try {
            const response = await fetch('/cart.json');
            if (!response.ok) {
                throw new Error(`Cart fetch failed: ${response.status}`);
            }
            const cartData = await response.json();
            return cartData;
        } catch (error) {
            console.error('Error fetching cart data:', error);
            return null;
        }
    }//eeee

    async processCartItems() {
        try {
            const cartData = await this.getCartData();
            if (!cartData || !cartData.items || cartData.items.length === 0) {
                console.log('No cart items found');
                return;
            }

            console.log('Processing cart items:', cartData.items);
            
            // Collect all product IDs that need metafields
            const productIdsToFetch = [];
            const itemsToUpdate = [];
            
            for (const item of cartData.items) {
                const hasMetafieldProperties = this.targetMetafields.some(key => 
                    item.properties && item.properties[`_${key}`]
                );
                
                if (!hasMetafieldProperties && item.product_id) {
                    productIdsToFetch.push(item.product_id);
                    itemsToUpdate.push(item);
                }
            }
            
            if (productIdsToFetch.length === 0) {
                console.log('No items need metafield updates');
                return;
            }
            
            // Fetch all metafields in one GraphQL call
            console.log('Fetching metafields for products:', productIdsToFetch);
            const productMetafieldsMap = await this.fetchProductsMetafields(productIdsToFetch);
            
            // Update cart line items with their respective metafields
            for (const item of itemsToUpdate) {
                const metafields = productMetafieldsMap[item.product_id];
                if (metafields && Object.keys(metafields).length > 0) {
                    debugger
                    await this.updateCartLineProperties(item.key, metafields);
                } else {
                    console.log('No target metafields found for product:', item.product_id);
                }
            }
        } catch (error) {
            console.error('Error processing cart items:', error);
        }
    }

    setupURLChangeListener() {
        // Backup the original XMLHttpRequest send method
        this.originalSend = XMLHttpRequest.prototype.send;
        const self = this;
    
        // Override XMLHttpRequest's send method to globally handle specific API calls
        XMLHttpRequest.prototype.send = function () {
            // Store the URL for later reference
            this._url = this._url || arguments[0];
            
            // Attach a listener for when the request loads (completes successfully)
            this.addEventListener("load", function () {
                // Check if the current request URL matches any of the target patterns
                const isTargetRequest = self.targetUrlPatterns.some(
                    (pattern) => this._url.includes(pattern)
                );
        
                if (isTargetRequest) {
                    // Delay execution to ensure any asynchronous data is ready
                    setTimeout(() => {
                        self.syncUTMsToCart();
                        
                        // Process cart items after cart operations
                        if (this._url.includes('add')) {
                            // Wait a bit for cart to be updated, then fetch cart data
                            setTimeout(() => {
                                self.processCartItems();
                            }, 500);
                        }
                    }, 400);
                }
            });
        
            // Call the original send method with the original arguments
            return self.originalSend.apply(this, arguments);
        };
    
        // Backup the original fetch function
        this.originalFetch = window.fetch;
    
        // Override the global fetch method to monitor specific API calls
        window.fetch = function (...fetchArgs) {
            const requestUrl = fetchArgs[0]; // The first argument is the request URL
    
            // Call the original fetch and handle the response
            return self.originalFetch.apply(this, fetchArgs).then(async (response) => {
                if (!response.ok) {
                    // If the response is not successful, return it as is
                    return response;
                }
    
                try {
                    // Check if the response URL matches any target patterns
                    const isTargetResponse = self.targetUrlPatterns.some(
                        (pattern) => response.url.includes(pattern)
                    );
    
                    if (isTargetResponse) {
                        // Delay execution to handle any dependent asynchronous processes
                        setTimeout(() => {
                            self.syncUTMsToCart();
                            
                            // Process cart items after cart operations
                            if (response.url.includes('add')) {
                                // Wait a bit for cart to be updated, then fetch cart data
                                setTimeout(() => {
                                    self.processCartItems();
                                }, 500);
                            }
                        }, 400);
                    }
                } catch (error) {
                    console.warn(
                        "[shop_events_listener] Error handling fetch request:",
                        error.message
                    );
                }
    
                return response;
            });
        };
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new SyncUTMsToCart();
});
